import { useContext, useEffect } from 'react';
import { Box, Button, Heading, Icon, Paragraph } from '@zillow/constellation-10';
import { IconRateUnhappyFilled } from '@zillow/constellation-icons';
import { useIdVerificationCallbacks } from '../../../IdvContext';
import { ExitReason } from '../../../../../models';
import { WizardStepId } from '../../../wizard/wizardTypes';
import { WizardContext } from '../../../wizard/WizardContext';

export default function ErrorFrozenAccountWarningStep() {
  const { setOnNext, goToStep } = useContext(WizardContext);
  const { onExit } = useIdVerificationCallbacks();

  useEffect(() => {
    setOnNext(() => () => goToStep(WizardStepId.PersonalInfo));
    return () => setOnNext(null);
  }, [goToStep, setOnNext]);

  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default' }}>
      <Icon size="lg" css={{ color: 'icon.subtle' }}>
        <IconRateUnhappyFilled />
      </Icon>
      <Heading level={2} textStyle="heading-sm">
        Have you contacted Experian and unlocked your credit file?
      </Heading>
      <Paragraph>
        Our records indicate that your last attempt to verify your identity resulted in a frozen credit file
        notification from Experian. Continued attempts to verify your identity with a frozen credit file will result in
        a temporary lockout of the rental application service.
      </Paragraph>
      <Button
        tone="brand"
        emphasis="outlined"
        onClick={() => onExit({ reason: ExitReason.FrozenAccountWarning, success: false })}
      >
        No
      </Button>
    </Box>
  );
}
